"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgeBaseDocumentType = void 0;
exports.KnowledgeBaseDocumentType = {
    File: "file",
    Url: "url",
    Text: "text",
};
